export default __webpack_public_path__ + "static/media/gift.5a94001f.png";